"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeetingsBoldReportPageActions;
(function (MeetingsBoldReportPageActions) {
    MeetingsBoldReportPageActions["LoadedBoldReportsViewer"] = "LoadedBoldReportsViewer";
})(MeetingsBoldReportPageActions || (MeetingsBoldReportPageActions = {}));
exports.default = MeetingsBoldReportPageActions;
